@if (crmBannerPromotions.length) {
    <ms-crm-promotion-container [promotions]="crmBannerPromotions" />
}
@if (vm.fixture) {
    <section class="antepost-fixture">
        <header class="antepost-fixture__header">
            @if (vm.isGolf) {
                <div>
                    <h2 class="antepost-fixture__name-container">
                        <span class="antepost-fixture__name" marquee>{{ vm.fixtureTitle }}</span>
                        @if (!vm.isGolf) {
                            <span class="antepost-fixture__location fixture-label">{{ vm.fixture.region.name | msTranslate }}</span>
                        }
                    </h2>
                    <span class="fixture-label">{{ vm.fixture.startDate | date: 'd MMM HH:mm' }}</span>
                </div>
            } @else {
                <div>
                    <div class="antepost-fixture-back-fixture-name">
                        <div class="breadcrumb-back">
                            <button
                                ds-button-icon
                                class="breadcrumb-theme-left"
                                variant="flat-reduced"
                                kind="tertiary"
                                size="medium"
                                (click)="goBack()">
                                <vn-icon name="theme-left" height="14" width="14" />
                            </button>
                            <div class="location-name">
                                <strong> {{ vm.fixtureTitle }} </strong>
                            </div>

                            <div class="fixture-label">
                                {{ vm.fixture.startDate | date: 'dd/MM/yyyy HH:mma' | uppercase }}
                            </div>
                        </div>
                    </div>
                    <div class="win-market">
                        <header msTextAutoScroll [marqueeAutoScroll]="true">
                            <div>
                                <ms-fixture-market-title [fixture]="vm.fixture" />
                            </div>
                        </header>
                    </div>
                </div>
            }
        </header>
        <ms-antepost-market [fixture]="vm.fixture" [showFixtureMarketTitle]="vm.isGolf" [skipSortingTracking]="vm.isGolf" />
    </section>
} @else {
    <ms-error [links]="false" [message]="sitecore.fixture.common.ErrorNoFixture" [severity]="'info'" />
}
